<template>
  <div class="banner swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item, index) in bannerData" :key="index"><a @click="wheretoGo(item.class_id, item.jump_type, item.signup)" ><img :src="item.image" width="100%" :alt="item.class_id"></a></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import {jsbsBanner} from '../../../request/api'
import jumpUrl from '../../../assets/js/common'
export default {
  name: 'jszgBanner',
  props: [
    'selectPeriodNum',
    'period'
  ],
  data () {
    return {
      bannerData: {},
      bannerSwiperOb: null
    }
  },
  methods: {
    // 获得 banner
    getBanner () {
      let data = {
        subject: this.selectPeriodNum,
        period: this.period,
        page: 1
      }
      jsbsBanner(data)
        .then(res => {
          console.log('banner:')
          console.log(res)
          this.bannerData = res
          let lbtState = true
          if (this.bannerData.length === 1) {
            lbtState = false
          }
          this.$nextTick(() => { // 下一帧渲染
            this.bannerSwiper(lbtState)
          })
        })
        .catch(err => { console.log(err) })
    },
    // 创建轮播图
    bannerSwiper (playState) {
      this.bannerSwiperOb = new Swiper('.banner.swiper-container', {
        // effect: 'coverflow',
        speed: 500,
        autoplay: {
          autoplay: true,
          delay: 2000
        },
        loop: playState,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true // 修改swiper的父元素时，自动初始化swiper
      })
    },
    wheretoGo (classId, jumpType, signUp) {
      if (jumpType === 11) {
        this.easyChat()
        return false
      }
      jumpUrl(classId, jumpType, signUp)
    }
    /*
    jumpUrl (classId, jumpType, signUp) {
      switch (jumpType) {
        case 0: // 0 不跳转
          event.preventDefault()
          break
        case 1: // 1 h5连接[资讯]
          this.$router.push(classId)
          break
        case 2: // 2 课程列表【合集id】 暂时用不到
          if (signUp) {
            this.$router.push({name: 'VideoPlay', query: {class_id: classId}})
          } else {
            this.$router.push({name: 'ClassDetailTeacher', query: {class_id: classId}})
          }
          break
        case 3: // 3 班级详情【班级id】
          if (signUp) {
            this.$router.push({name: 'VideoPlay', query: {class_id: classId}})
          } else {
            this.$router.push({name: 'ClassDetailTeacher', query: {class_id: classId}})
          }
          break
        case 4: // 4 h5连接[活动]
          this.$router.push(classId)
          break
      }
    }
*/
  },
  watch: {
    selectPeriodNum () {
      this.getBanner()
    }
  },
  mounted () {
    this.getBanner()
  }
}
</script>

<style scoped lang="stylus">
  .banner
    height: 3.2rem
    overflow: hidden
    .swiper-wrapper
      width: 100%
      transform:translate3d(0,0,0)
        overflow:hidden
      .swiper-slide
        width: 100%
        transform:translate3d(0,0,0)
        overflow: hidden
    img
      width: 100%
      height: 100%
</style>



// WEBPACK FOOTER //
// src/components/share/plug/jszgBanner.vue